import moment from 'moment';

/**
 * Checks if date passed is today.
 * @param {string} dateIn - date
 * @returns {boolean}
 */
export const isToday = dateIn => {
  if (dateIn) {
    const TODAY = moment().clone().startOf('day');
    return moment(dateIn).isSame(TODAY, 'd');
  }

  return false;
};
